import * as _ from "underscore";

interface IDecisionProps {
  available_funds: number;
}

export default class LoanApplication {
  borrower1_first_name: string;

  borrower1_last_name: string;

  borrower1_ssn: string;

  borrower1_dob: string;

  borrower1_email: string;

  borrower1_phone: string;

  borrower1_password: string;

  borrower1_estimated_income: number;

  borrower1_estimated_yearly_income: number;

  borrower1_filed_last_years_taxes: boolean;

  borrower1_current_address_line1: string;

  borrower1_current_address_line2: string;

  borrower1_current_city: string;

  borrower1_current_state: string;

  borrower1_current_postal_code: string;

  borrower1_relationship_status: string;

  borrower1_ownership_status: string;

  borrower1_current_move_in_date: string;

  borrower1_monthly_rent: number;

  borrower2_first_name: string;

  borrower2_ssn: string;

  borrower2_email: string;

  borrower2_phone: string;

  borrower2_filed_last_years_taxes: boolean;

  borrower2_relationship_status: string;

  amount_exists: number;

  property_city: string;

  property_state: string;

  borrower_estimated_purchase_price: number;

  borrower_estimated_down_payment: number;

  property_usage: string;

  property_type: string;

  authorized_credit: boolean;

  borrower_estimated_loan_amount: number;

  have_at_least: number;

  accounts: any[];

  employments: any[];

  past_residences: any[];

  explanations: any[];

  decision: IDecisionProps;

  settlement_agent_name: string;

  documents: any[];

  wvoe: any;

  mood: string;

  owned_real_estate: any[];

  lead_number: string;

  has_borrower2: boolean;

  constructor() {
    this.borrower1_first_name = "";
    this.borrower1_last_name = "";
    this.borrower1_ssn = "";
    this.borrower1_dob = "";
    this.borrower1_email = "";
    this.borrower1_phone = "";
    this.borrower1_password = null;
    this.borrower1_estimated_income = null;
    this.borrower1_estimated_yearly_income = null;
    this.borrower1_current_address_line1 = "";
    this.borrower1_current_address_line2 = "";
    this.borrower1_current_city = "";
    this.borrower1_current_state = "";
    this.borrower1_current_postal_code = "";
    this.borrower1_ownership_status = "";
    this.borrower1_current_move_in_date = "";
    this.borrower1_monthly_rent = null;
    this.property_city = "";
    this.property_state = "";
    this.borrower_estimated_purchase_price = null;
    this.borrower_estimated_down_payment = null;
    this.accounts = [];
    this.employments = [];
    this.past_residences = [];
    this.explanations = [];
    this.decision = {
      available_funds: null,
    };
    this.settlement_agent_name = null;
    this.documents = [];
    this.mood = "";
    this.borrower1_relationship_status = "";
  }

  isComplete(): boolean {
    this.borrower_estimated_loan_amount =
      this.borrower_estimated_purchase_price - this.borrower_estimated_down_payment;
    return (
      this.hasPropertyLocation() &&
      this.hasPropertyFinancial() &&
      this.hasPropertyUsage() &&
      this.hasPropertyType() &&
      this.hasPersonalInfo() &&
      this.authorized_credit
    );
  }

  isDisqualified(): boolean {
    if (!this.hasPropertyFinancial() || !this.hasPropertyUsage() || !this.hasPropertyType()) {
      return false;
    }

    return (
      this.purchasePriceAboveMaximum() ||
      this.downPaymentBelowMinimum() ||
      this.incomeBelowMinimum() ||
      this.loanAmountTooHigh() ||
      this.unsupportedPropertyUsage() ||
      this.unsupportedPropertyType() ||
      this.unsupportedPropertyUsageAndType()
    );
  }

  payload() {
    return _.extend(_.clone(this), {
      borrower_estimated_purchase_price: this.borrower_estimated_purchase_price,
      borrower_estimated_down_payment: this.borrower_estimated_down_payment,
      borrower1_estimated_income: this.borrower1_estimated_income,
      borrower1_estimated_yearly_income: this.borrower1_estimated_yearly_income,
    });
  }

  hasPropertyLocation(): boolean {
    return !!this.property_city && !!this.property_state;
  }

  hasPropertyFinancial(): boolean {
    return (
      !!this.borrower_estimated_purchase_price &&
      !!this.borrower_estimated_down_payment &&
      !!this.borrower1_estimated_income &&
      !!this.borrower1_estimated_yearly_income
    );
  }

  hasPropertyUsage(): boolean {
    return !!this.property_usage;
  }

  hasPropertyType(): boolean {
    return !!this.property_type;
  }

  hasPersonalInfo(): boolean {
    return (
      !!this.borrower1_first_name &&
      !!this.borrower1_last_name &&
      !!this.borrower1_dob &&
      !!this.borrower1_email &&
      !!this.borrower1_phone &&
      !!this.borrower1_password &&
      !!this.borrower1_current_address_line1 &&
      !!this.borrower1_current_city &&
      !!this.borrower1_current_state &&
      !!this.borrower1_current_postal_code &&
      !!this.borrower1_current_move_in_date
    );
  }

  purchasePriceAboveMaximum(): boolean {
    return this.hasPropertyFinancial() && this.borrower_estimated_purchase_price > 10000000;
  }

  downPaymentBelowMinimum(): boolean {
    return (
      this.hasPropertyFinancial() &&
      this.borrower_estimated_down_payment < this.borrower_estimated_purchase_price * 0.15
    );
  }

  incomeBelowMinimum(): boolean {
    return (
      this.hasPropertyFinancial() &&
      this.borrower1_estimated_income < this.borrower_estimated_loan_amount * 0.0085
    );
  }

  loanAmountTooHigh(): boolean {
    return this.borrower_estimated_purchase_price - this.borrower_estimated_down_payment > 5000000;
  }

  unsupportedPropertyUsage(): boolean {
    return this.property_usage !== "primary" && this.property_usage !== "secondary";
  }

  unsupportedPropertyType(): boolean {
    return (
      this.property_type === "co_op" ||
      this.property_type === "multi_family_building_large" ||
      this.property_type === "other"
    );
  }

  unsupportedPropertyUsageAndType(): boolean {
    return (
      this.property_usage === "secondary" &&
      (this.property_type === "multi_family_building" ||
        this.property_type === "multi_family_building_large")
    );
  }
}
